import { gql } from "@apollo/client";

const GET_ORDERS = gql`
  query orders($params: QueryParams, $invoiceId: ID) {
    orders(params: $params, invoiceId: $invoiceId) {
      results {
        id
        status
        reference
        client {
          user {
            firstName
            lastName
          }
        }

        updatedAt
        createdAt
      }
      info {
        count
      }
    }
  }
`;

export { GET_ORDERS };
